
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M260.2 298.6c-3 3-6.4 4.5-10.2 4.5s-7.2-1.5-10.2-4.5L3.4 62.2C1.1 59.2 0 55.8 0 52c0-3.8 1.1-6.8 3.4-9L26 20.4c2.3-3 5.3-4.5 9-4.5 3.8 0 7.2 1.5 10.2 4.5L250 225.1 454.8 20.4c3-3 6.4-4.5 10.2-4.5s6.8 1.5 9 4.5L496.6 43c2.3 2.3 3.4 5.3 3.4 9 0 3.8-1.1 7.2-3.4 10.2L260.2 298.6zM474 201.4c-2.3-3-5.3-4.5-9-4.5s-7.2 1.5-10.2 4.5L250 406.1 45.2 201.4c-3-3-6.4-4.5-10.2-4.5-3.8 0-6.8 1.5-9 4.5L3.4 224c-2.3 2.3-3.4 5.3-3.4 9s1.1 7.2 3.4 10.2L241 479.6c2.3 3 5.3 4.5 9 4.5s7.2-1.5 10.2-4.5l236.4-236.4c2.3-3 3.4-6.4 3.4-10.2s-1.1-6.8-3.4-9L474 201.4z"}})])
          )
        }
      }
    